function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ALGOLIA_COLOR_ATTRIBUTE, ALGOLIA_PLP_FACETS, ALGOLIA_PRICE_ATTRIBUTE, ALGOLIA_PRICE_FILTER_SCALE, ALGOLIA_SALE_ATTRIBUTE, ALGOLIA_SALE_TOGGLE_VALUE, algoliaPriceToShopifyCents, getAlgoliaProductIndexName, getAlgoliaSortReplicas } from 'lib/algolia/constants';
import { createAlgoliaPlp } from 'lib/algolia';
import { parsePreselectedFiltersFromRoot } from 'lib/algolia/parse-default-filters';
import { renderProductCard, setAlgoliaSwatchColorLookup } from 'lib/algolia/algolia-product-card-html';
import { getAlgoliaClient } from 'lib/algolia/algolia-client';
import { fetchPopularTerms } from 'lib/algolia/algolia-popular-terms';
import { formatMoney } from '@shopify/theme-currency';
import { mountVideoBlocks } from 'snippets/video-player/video-block';
import './_algolia-listing.scss';
import 'snippets/card/card';

// ---------------------------------------------------------------------------
// Config
// ---------------------------------------------------------------------------

var COLLECTIONS_FACET = 'collections';
var PRICE_RANGE_DEBOUNCE_MS = 400;
var SEARCH_HEADER_DEBOUNCE_MS = 300;
var DEFAULT_FACET_LIMIT = 10;
var SEARCH_EMPTY_STATE_CHIPS_LIMIT = 8;
var SEPARATE_CARD_FILTER_ATTR = 'meta.merchandising.show_as_separate_card';

// ---------------------------------------------------------------------------
// Separate card merging
// ---------------------------------------------------------------------------

function colorFromHit(hit) {
  var _hit$options$color, _hit$options;
  return String((_hit$options$color = hit === null || hit === void 0 || (_hit$options = hit.options) === null || _hit$options === void 0 ? void 0 : _hit$options.color) !== null && _hit$options$color !== void 0 ? _hit$options$color : '').trim().toLowerCase();
}
function separateCardIncludesCollection(hit, collectionHandle) {
  var _hit$SEPARATE_CARD_FI, _hit$meta;
  var raw = (_hit$SEPARATE_CARD_FI = hit === null || hit === void 0 ? void 0 : hit[SEPARATE_CARD_FILTER_ATTR]) !== null && _hit$SEPARATE_CARD_FI !== void 0 ? _hit$SEPARATE_CARD_FI : hit === null || hit === void 0 || (_hit$meta = hit.meta) === null || _hit$meta === void 0 || (_hit$meta = _hit$meta.merchandising) === null || _hit$meta === void 0 ? void 0 : _hit$meta.show_as_separate_card;
  if (!raw) return false;
  var str = String(raw).trim();
  // Support both comma-separated plain strings and JSON-encoded arrays
  var handles;
  if (str.startsWith('[')) {
    try {
      handles = JSON.parse(str);
    } catch (_unused) {
      handles = [str];
    }
  } else {
    handles = str.split(',');
  }
  var target = String(collectionHandle).trim().toLowerCase();
  return handles.some(h => String(h).trim().toLowerCase() === target);
}
function mergeSeparateCardHits(primaryHits, separateCardHits, collectionHandle) {
  if (!separateCardHits.length) return primaryHits;
  var primaryIndexById = new Map();
  for (var i = 0; i < primaryHits.length; i++) {
    var _primaryHits$i$id;
    var productId = String((_primaryHits$i$id = primaryHits[i].id) !== null && _primaryHits$i$id !== void 0 ? _primaryHits$i$id : '');
    if (productId && !primaryIndexById.has(productId)) {
      primaryIndexById.set(productId, i);
    }
  }

  // Track colours already represented per product (lead card colours are seeded in)
  var seenColorKeys = new Set();
  for (var hit of primaryHits) {
    var _hit$id;
    var _productId = String((_hit$id = hit.id) !== null && _hit$id !== void 0 ? _hit$id : '');
    var color = colorFromHit(hit);
    if (_productId && color) seenColorKeys.add("".concat(_productId, ":").concat(color));
  }
  // { afterIndex, hit } pairs to splice in, grouped per product to preserve order
  var insertions = [];
  for (var _hit of separateCardHits) {
    var _hit$id2;
    if (collectionHandle && !separateCardIncludesCollection(_hit, collectionHandle)) continue;
    var _productId2 = String((_hit$id2 = _hit.id) !== null && _hit$id2 !== void 0 ? _hit$id2 : '');
    var _color = colorFromHit(_hit);
    var colorKey = "".concat(_productId2, ":").concat(_color);
    if (_color && seenColorKeys.has(colorKey)) continue;
    if (_color) seenColorKeys.add(colorKey);
    if (!primaryIndexById.has(_productId2)) continue;
    var afterIndex = primaryIndexById.get(_productId2);
    insertions.push({
      afterIndex,
      hit: _objectSpread(_objectSpread({}, _hit), {}, {
        _separateCard: true
      })
    });
  }

  // Process in reverse index order so earlier splices don't shift later indices
  insertions.sort((a, b) => b.afterIndex - a.afterIndex);
  var result = [...primaryHits];
  for (var _ref2 of insertions) {
    var _afterIndex = _ref2.afterIndex;
    var _hit2 = _ref2.hit;
    result.splice(_afterIndex + 1, 0, _hit2);
  }
  return result;
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

function moneyFormat(value) {
  var _window$theme;
  var n = Number(value);
  if (Number.isNaN(n)) return '';
  return formatMoney(n, (_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : _window$theme.settingCurrencyFormat);
}
function escapeHtml(str) {
  var el = document.createElement('span');
  el.textContent = str;
  return el.innerHTML;
}
function decodeHtmlEntities(str) {
  var el = document.createElement('textarea');
  el.innerHTML = String(str !== null && str !== void 0 ? str : '');
  return el.value;
}
function unscopedCollectionHandlesList(raw) {
  var s = String(raw !== null && raw !== void 0 ? raw : 'all,all-products').trim();
  if (!s) return [];
  return s.split(/[\n,]+/).map(x => x.trim().toLowerCase()).filter(Boolean);
}

// ---------------------------------------------------------------------------
// Color group helpers
// ---------------------------------------------------------------------------

/** `data-algolia-color-groups` JSON → array (invalid / missing → []). */
function parseColorGroups(root) {
  var raw = root.dataset.algoliaColorGroups;
  if (!raw) return [];
  try {
    return JSON.parse(raw);
  } catch (_unused2) {
    return [];
  }
}

/** `custom.swatch_data` JSON: `{ "Label": { "hex", "image" } }` → `{ color, image }` for cards. */
function readAlgoliaSwatchColorLookup(root) {
  var _el$textContent;
  var el = root.querySelector('[data-algolia-swatch-colors]');
  var text = el === null || el === void 0 || (_el$textContent = el.textContent) === null || _el$textContent === void 0 ? void 0 : _el$textContent.trim();
  if (!text) return {};
  var map;
  try {
    map = JSON.parse(text);
  } catch (_unused3) {
    return {};
  }
  var lookup = {};
  for (var _ref5 of Object.entries(map || {})) {
    var _ref6, _entry$hex, _entry$image;
    var _ref4 = _slicedToArray(_ref5, 2);
    var label = _ref4[0];
    var entry = _ref4[1];
    if (!entry || typeof entry !== 'object') continue;
    lookup[label] = {
      color: String((_ref6 = (_entry$hex = entry.hex) !== null && _entry$hex !== void 0 ? _entry$hex : entry.color) !== null && _ref6 !== void 0 ? _ref6 : '').trim(),
      image: String((_entry$image = entry.image) !== null && _entry$image !== void 0 ? _entry$image : '').trim()
    };
  }
  return lookup;
}

/** `data-algolia-inline-content` JSON -> normalized inline-content rows. */
function parseInlineContentRows(root) {
  var raw = root.dataset.algoliaInlineContent;
  if (!raw) return [];
  var rows;
  try {
    rows = JSON.parse(raw);
  } catch (_unused4) {
    return [];
  }
  if (!Array.isArray(rows)) return [];
  var normalized = rows.map((row, index) => {
    var _row$id, _row$title, _row$content, _ref7, _row$cta_link_url, _row$cta_link, _ref8, _row$cta_link_text, _row$cta_link2, _row$media;
    var id = String((_row$id = row === null || row === void 0 ? void 0 : row.id) !== null && _row$id !== void 0 ? _row$id : "inline-".concat(index)).trim();
    var title = String((_row$title = row === null || row === void 0 ? void 0 : row.title) !== null && _row$title !== void 0 ? _row$title : '').trim();
    var content = String((_row$content = row === null || row === void 0 ? void 0 : row.content) !== null && _row$content !== void 0 ? _row$content : '').trim();
    var ctaLinkUrl = String((_ref7 = (_row$cta_link_url = row === null || row === void 0 ? void 0 : row.cta_link_url) !== null && _row$cta_link_url !== void 0 ? _row$cta_link_url : row === null || row === void 0 || (_row$cta_link = row.cta_link) === null || _row$cta_link === void 0 ? void 0 : _row$cta_link.url) !== null && _ref7 !== void 0 ? _ref7 : '').trim();
    var ctaLinkText = String((_ref8 = (_row$cta_link_text = row === null || row === void 0 ? void 0 : row.cta_link_text) !== null && _row$cta_link_text !== void 0 ? _row$cta_link_text : row === null || row === void 0 || (_row$cta_link2 = row.cta_link) === null || _row$cta_link2 === void 0 ? void 0 : _row$cta_link2.text) !== null && _ref8 !== void 0 ? _ref8 : '').trim();
    var media = String((_row$media = row === null || row === void 0 ? void 0 : row.media) !== null && _row$media !== void 0 ? _row$media : '').trim();
    var positionNum = Number(row === null || row === void 0 ? void 0 : row.position);
    var position = Number.isInteger(positionNum) ? positionNum : null;
    if (!position || position < 1) return null;
    if (!title && !content && !ctaLinkUrl && !media) return null;
    return {
      id: id || "inline-".concat(index),
      title,
      content,
      ctaLinkUrl,
      ctaLinkText,
      media,
      position,
      sourceIndex: index
    };
  }).filter(Boolean);
  normalized.sort((a, b) => {
    if (a.position !== b.position) return a.position - b.position;
    return a.sourceIndex - b.sourceIndex;
  });
  return normalized;
}

/** `data-algolia-inline-featured-products` JSON -> normalized featured rows. */
function parseInlineFeaturedProductRows(root) {
  var raw = root.dataset.algoliaInlineFeaturedProducts;
  if (!raw) return [];
  var rows;
  try {
    rows = JSON.parse(raw);
  } catch (_unused5) {
    return [];
  }
  if (!Array.isArray(rows)) return [];

  // Featured cards span 2 columns on desktop (4-col grid). Prevent starts on
  // column 4 so they don't overflow
  var normalizeFeaturedPosition = position => position % 4 === 0 ? position - 1 : position;
  var normalized = rows.map((row, index) => {
    var _row$id2, _row$variant_id, _row$product_url, _row$title2, _row$collection_label, _row$image, _row$video, _row$video_poster;
    var id = String((_row$id2 = row === null || row === void 0 ? void 0 : row.id) !== null && _row$id2 !== void 0 ? _row$id2 : "inline-featured-".concat(index)).trim();
    var positionNum = Number(row === null || row === void 0 ? void 0 : row.position);
    var position = Number.isInteger(positionNum) ? positionNum : null;
    var variantId = String((_row$variant_id = row === null || row === void 0 ? void 0 : row.variant_id) !== null && _row$variant_id !== void 0 ? _row$variant_id : '').trim();
    var productUrl = String((_row$product_url = row === null || row === void 0 ? void 0 : row.product_url) !== null && _row$product_url !== void 0 ? _row$product_url : '').trim();
    var title = String((_row$title2 = row === null || row === void 0 ? void 0 : row.title) !== null && _row$title2 !== void 0 ? _row$title2 : '').trim();
    var collectionLabel = String((_row$collection_label = row === null || row === void 0 ? void 0 : row.collection_label) !== null && _row$collection_label !== void 0 ? _row$collection_label : '').trim();
    var image = String((_row$image = row === null || row === void 0 ? void 0 : row.image) !== null && _row$image !== void 0 ? _row$image : '').trim();
    var video = String((_row$video = row === null || row === void 0 ? void 0 : row.video) !== null && _row$video !== void 0 ? _row$video : '').trim();
    var videoPoster = String((_row$video_poster = row === null || row === void 0 ? void 0 : row.video_poster) !== null && _row$video_poster !== void 0 ? _row$video_poster : '').trim();
    var price = Number(row === null || row === void 0 ? void 0 : row.price);
    var compareAtPrice = Number(row === null || row === void 0 ? void 0 : row.compare_at_price);
    if (!position || position < 1) return null;
    if (!variantId || !productUrl || !title) return null;
    if (!image && !video) return null;
    return {
      id: id || "inline-featured-".concat(index),
      position,
      normalizedPosition: normalizeFeaturedPosition(position),
      variantId,
      productUrl,
      title,
      collectionLabel,
      image,
      video,
      videoPoster,
      price,
      compareAtPrice,
      sourceIndex: index
    };
  }).filter(Boolean);
  normalized.sort((a, b) => {
    if (a.position !== b.position) return a.position - b.position;
    return a.sourceIndex - b.sourceIndex;
  });
  return normalized;
}
function renderInlineContentCard(item) {
  var media = item.media ? "<div class=\"algolia-inline-content__media-wrap\"><img class=\"algolia-inline-content__media\" src=\"".concat(escapeHtml(item.media), "\" alt=\"").concat(escapeHtml(item.title || ''), "\" loading=\"lazy\" decoding=\"async\" /></div>") : '';
  var coverLink = item.ctaLinkUrl ? "<a class=\"algolia-inline-content__cover-link\" href=\"".concat(escapeHtml(item.ctaLinkUrl), "\" aria-label=\"").concat(escapeHtml(item.ctaLinkText || item.title || 'Learn more'), "\"></a>") : '';
  var title = item.title ? "<h3 class=\"algolia-inline-content__title\">".concat(escapeHtml(item.title), "</h3>") : '';
  var content = item.content ? "<p class=\"algolia-inline-content__copy\">".concat(escapeHtml(item.content), "</p>") : '';
  var cta = item.ctaLinkUrl ? "<span class=\"algolia-inline-content__cta\">".concat(escapeHtml(item.ctaLinkText || 'Learn more'), "<svg class=\"icon icon--arrow-right algolia-inline-content__cta-icon\" aria-hidden=\"true\" focusable=\"false\" width=\"16\" height=\"16\"><use xlink:href=\"#icon-arrow--right\"></use></svg></span>") : '';
  return "<li class=\"algolia-hits__item algolia-hits__item--inline-content\" data-inline-content-id=\"".concat(escapeHtml(item.id), "\"><article class=\"algolia-inline-content\">").concat(coverLink).concat(media, "<div class=\"algolia-inline-content__body\">").concat(title).concat(content).concat(cta, "</div></article></li>");
}
function renderInlineFeaturedProductCard(item) {
  var url = escapeHtml(item.productUrl);
  var collection = escapeHtml(item.collectionLabel);
  var title = escapeHtml(item.title);
  var titleId = "inline-featured-title-".concat(escapeHtml(item.id));
  var price = Number.isFinite(item.price) ? item.price : 0;
  var compareAt = Number.isFinite(item.compareAtPrice) ? item.compareAtPrice : 0;
  var showCompare = compareAt > price;
  var compareHtml = showCompare ? escapeHtml(moneyFormat(algoliaPriceToShopifyCents(compareAt))) : '';
  var currentHtml = escapeHtml(moneyFormat(algoliaPriceToShopifyCents(price)));
  var media = item.video ? "<div class=\"algolia-inline-featured__media-wrap\"><div class=\"video-block video-block--html5 video-block--is-paused".concat(item.videoPoster ? ' video-block--is-postered' : '', "\" data-autoplay-in-view=\"true\"").concat(item.videoPoster ? " style=\"background-position:50% 50%;background-image:url(".concat(escapeHtml(item.videoPoster), ")\"") : '', "><div class=\"video-block__controls video-block__controls-static video-block__controls-bar\"><button class=\"video-block__control video-block__control--media-toggle\" type=\"button\" data-label-play=\"Play video\" data-label-pause=\"Pause video\" aria-pressed=\"false\" aria-label=\"Pause video\"><span class=\"video-block__media-toggle-icon video-block__media-toggle-icon--play\" aria-hidden=\"true\"><svg class=\"icon icon-play\" aria-hidden=\"true\" focusable=\"false\"><use xlink:href=\"#icon-play\"></use></svg></span><span class=\"video-block__media-toggle-icon video-block__media-toggle-icon--pause\" aria-hidden=\"true\"><svg class=\"icon icon-pause\" aria-hidden=\"true\" focusable=\"false\"><use xlink:href=\"#icon-pause\"></use></svg></span></button></div><video class=\"video-block__video algolia-inline-featured__video\" ").concat(item.videoPoster ? "poster=\"".concat(escapeHtml(item.videoPoster), "\"") : '', " muted loop playsinline preload=\"metadata\"><source src=\"").concat(escapeHtml(item.video), "\" /></video></div></div>") : "<div class=\"algolia-inline-featured__media-wrap\"><img class=\"algolia-inline-featured__image\" src=\"".concat(escapeHtml(item.image), "\" alt=\"").concat(title, "\" loading=\"lazy\" decoding=\"async\" /></div>");
  return "<li class=\"algolia-hits__item algolia-hits__item--inline-featured\" data-inline-featured-id=\"".concat(escapeHtml(item.id), "\"><article class=\"algolia-inline-featured\">").concat(media, "<a href=\"").concat(url, "\" class=\"algolia-inline-featured__cover-link\" aria-labelledby=\"").concat(titleId, "\"></a><div class=\"algolia-inline-featured__body\"><div class=\"algolia-inline-featured__collection\">").concat(collection, "</div><h3 class=\"algolia-inline-featured__title\" id=\"").concat(titleId, "\">").concat(title, "</h3><div class=\"algolia-inline-featured__price-row\"><div class=\"algolia-inline-featured__price\"><s class=\"algolia-inline-featured__compare\" ").concat(showCompare ? '' : 'hidden', ">").concat(compareHtml, "</s><span class=\"algolia-inline-featured__current\">").concat(currentHtml, "</span></div></div></div></article></li>");
}

/** Colour metaobject groups that have at least one selected Algolia facet value. */
function countSelectedColorGroups(selectedValues, colorGroups) {
  return colorGroups.filter(g => (g.included_colors || []).some(c => selectedValues.includes(c))).length;
}

/**
 * Compute active filter count, treating color groups as single selections
 * rather than counting each included_color individually.
 */
function computeActiveFilterCount(state, colorGroups) {
  var count = Object.keys(state.numericRange).length;
  for (var _ref1 of Object.entries(state.refinements)) {
    var _ref0 = _slicedToArray(_ref1, 2);
    var attr = _ref0[0];
    var values = _ref0[1];
    if (attr === ALGOLIA_COLOR_ATTRIBUTE && colorGroups.length > 0) {
      count += countSelectedColorGroups(values, colorGroups);
    } else {
      count += values.length;
    }
  }
  return count;
}
function shouldApplyCollectionFacetFilter(_ref10) {
  var mode = _ref10.mode,
    collectionHandle = _ref10.collectionHandle,
    config = _ref10.config;
  if (mode !== 'collection' || !collectionHandle) return false;
  var handle = String(collectionHandle).trim().toLowerCase();
  return !unscopedCollectionHandlesList(config.unscopedCollectionHandles).includes(handle);
}
function collectionFacetFilters(collectionFacetValue, apply) {
  if (!apply || !collectionFacetValue) return [];
  var val = String(collectionFacetValue).trim();
  return val ? ["".concat(COLLECTIONS_FACET, ":").concat(val)] : [];
}

// ---------------------------------------------------------------------------
// Render: hits grid
// ---------------------------------------------------------------------------

function renderHits(container, hits) {
  var inlineRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var featuredRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var append = options.append === true;
  var prepend = options.prepend === true;
  var streamIndexStart = Number(options.streamIndexStart) || 1;
  var alreadyInsertedInlineIds = options.alreadyInsertedInlineIds || new Set();
  var alreadyInsertedFeaturedIds = options.alreadyInsertedFeaturedIds || new Set();
  if (!hits.length && !append && !prepend) {
    container.innerHTML = '<p class="algolia-hits__empty">No products found.</p>';
    return {
      renderedItemCount: 0,
      insertedInlineIds: new Set(),
      insertedFeaturedIds: new Set()
    };
  }
  var nextInlineIdx = 0;
  while (nextInlineIdx < inlineRows.length && (alreadyInsertedInlineIds.has(inlineRows[nextInlineIdx].id) || inlineRows[nextInlineIdx].position < streamIndexStart)) {
    nextInlineIdx += 1;
  }
  var nextFeaturedIdx = 0;
  while (nextFeaturedIdx < featuredRows.length && (alreadyInsertedFeaturedIds.has(featuredRows[nextFeaturedIdx].id) || ((_featuredRows$nextFea = featuredRows[nextFeaturedIdx].normalizedPosition) !== null && _featuredRows$nextFea !== void 0 ? _featuredRows$nextFea : featuredRows[nextFeaturedIdx].position) < streamIndexStart)) {
    var _featuredRows$nextFea;
    nextFeaturedIdx += 1;
  }
  var renderedChunks = [];
  var streamIndex = streamIndexStart;
  var hitIdx = 0;
  var insertedInlineIds = new Set(alreadyInsertedInlineIds);
  var insertedFeaturedIds = new Set(alreadyInsertedFeaturedIds);
  var getCandidateAtSlot = () => {
    var _featured$normalizedP;
    var inline = inlineRows[nextInlineIdx];
    var featured = featuredRows[nextFeaturedIdx];
    var inlineMatches = inline && !insertedInlineIds.has(inline.id) && inline.position === streamIndex;
    var featuredMatches = featured && !insertedFeaturedIds.has(featured.id) && ((_featured$normalizedP = featured.normalizedPosition) !== null && _featured$normalizedP !== void 0 ? _featured$normalizedP : featured.position) === streamIndex;
    if (inlineMatches && featuredMatches) {
      return {
        kind: 'featured',
        item: featured
      };
    }
    if (featuredMatches) return {
      kind: 'featured',
      item: featured
    };
    if (inlineMatches) return {
      kind: 'inline',
      item: inline
    };
    return null;
  };
  while (hitIdx < hits.length) {
    var candidate = getCandidateAtSlot();
    if (candidate) {
      if (candidate.kind === 'featured') {
        renderedChunks.push(renderInlineFeaturedProductCard(candidate.item));
        insertedFeaturedIds.add(candidate.item.id);
        nextFeaturedIdx += 1;
      } else {
        renderedChunks.push(renderInlineContentCard(candidate.item));
        insertedInlineIds.add(candidate.item.id);
        nextInlineIdx += 1;
      }
      streamIndex += 1;
      continue;
    }
    renderedChunks.push(renderProductCard(hits[hitIdx]));
    hitIdx += 1;
    streamIndex += 1;
  }
  var trailingCandidate = getCandidateAtSlot();
  while (trailingCandidate) {
    var _candidate = trailingCandidate;
    if (_candidate.kind === 'featured') {
      renderedChunks.push(renderInlineFeaturedProductCard(_candidate.item));
      insertedFeaturedIds.add(_candidate.item.id);
      nextFeaturedIdx += 1;
    } else {
      renderedChunks.push(renderInlineContentCard(_candidate.item));
      insertedInlineIds.add(_candidate.item.id);
      nextInlineIdx += 1;
    }
    streamIndex += 1;
    trailingCandidate = getCandidateAtSlot();
  }
  if (append || prepend) {
    var list = container.querySelector('.algolia-hits__list');
    if (list) {
      list.insertAdjacentHTML(prepend ? 'afterbegin' : 'beforeend', renderedChunks.join(''));
      mountVideoBlocks(list);
    } else {
      container.innerHTML = "<ul class=\"algolia-hits__list\">".concat(renderedChunks.join(''), "</ul>");
      mountVideoBlocks(container);
    }
  } else {
    container.innerHTML = "<ul class=\"algolia-hits__list\">".concat(renderedChunks.join(''), "</ul>");
    mountVideoBlocks(container);
  }
  return {
    renderedItemCount: streamIndex - streamIndexStart,
    insertedInlineIds,
    insertedFeaturedIds
  };
}

// ---------------------------------------------------------------------------
// Render: refinement list facet
// ---------------------------------------------------------------------------

function renderRefinementList(container, facetValues, selectedValues, _ref11) {
  var limit = _ref11.limit,
    attribute = _ref11.attribute,
    plp = _ref11.plp;
  var entries = Object.entries(facetValues || {}).sort((a, b) => String(a[0]).localeCompare(String(b[0]), undefined, {
    sensitivity: 'base'
  }));
  if (entries.length === 0) {
    container.closest('.algolia-facet-group').hidden = true;
    container.innerHTML = '';
    return;
  }
  container.closest('.algolia-facet-group').hidden = false;
  var expanded = container.dataset.showAll === '1';
  var cap = expanded ? entries.length : limit || DEFAULT_FACET_LIMIT;
  var visible = entries.slice(0, cap);
  var hasMore = entries.length > (limit || DEFAULT_FACET_LIMIT);
  var items = visible.map(_ref12 => {
    var _ref13 = _slicedToArray(_ref12, 1),
      value = _ref13[0];
    var checked = selectedValues.includes(value);
    var id = "facet-".concat(attribute, "-").concat(value).replace(/[^a-zA-Z0-9_-]/g, '_');
    return "\n            <li class=\"algolia-refinement__item".concat(checked ? ' algolia-refinement__item--selected' : '', "\">\n                <label class=\"algolia-refinement__label\" for=\"").concat(id, "\">\n                    <input\n                        class=\"algolia-refinement__checkbox\"\n                        type=\"checkbox\"\n                        id=\"").concat(id, "\"\n                        data-attr=\"").concat(escapeHtml(attribute), "\"\n                        data-value=\"").concat(escapeHtml(value), "\"\n                        ").concat(checked ? 'checked' : '', "\n                    />\n                    <span class=\"algolia-refinement__text\">").concat(escapeHtml(value), "</span>\n                </label>\n            </li>");
  }).join('');
  var showMoreBtn = hasMore ? "<button type=\"button\" class=\"algolia-refinement__show-more\" data-attr=\"".concat(escapeHtml(attribute), "\">").concat(expanded ? 'Show less' : 'Show more', "</button>") : '';
  container.innerHTML = "<ul class=\"algolia-refinement__list\">".concat(items, "</ul>").concat(showMoreBtn);
  container.querySelectorAll('.algolia-refinement__checkbox').forEach(cb => {
    cb.addEventListener('change', () => {
      plp.toggleRefinement(cb.dataset.attr, cb.dataset.value);
    });
  });
  var moreBtn = container.querySelector('.algolia-refinement__show-more');
  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      container.dataset.showAll = container.dataset.showAll === '1' ? '0' : '1';
      renderRefinementList(container, facetValues, selectedValues, {
        limit,
        attribute,
        plp
      });
    });
  }
}

// ---------------------------------------------------------------------------
// Render: colour swatches (color_group metaobject-driven)
// ---------------------------------------------------------------------------

var CLOSE_SVG = '<svg class="icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 20 20"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"/></svg>';

/** Swatch markup for one color_group row (image or solid fill). */
function colorGroupSwatchHtml(group) {
  var imgUrl = group.swatch_image && String(group.swatch_image).trim();
  if (imgUrl) {
    var src = escapeHtml(imgUrl);
    return "<span class=\"algolia-color-swatch__swatch algolia-color-swatch__swatch--image\" aria-hidden=\"true\"><img class=\"algolia-color-swatch__img\" src=\"".concat(src, "\" alt=\"\" width=\"32\" height=\"32\" loading=\"lazy\" decoding=\"async\" /></span>");
  }
  var safeColor = escapeHtml(group.swatch_color || '#cccccc');
  return "<span class=\"algolia-color-swatch__swatch\" style=\"background-color:".concat(safeColor, "\" aria-hidden=\"true\"></span>");
}
function renderColorSwatches(container, facetValues, selectedValues, _ref14) {
  var attribute = _ref14.attribute,
    colorGroups = _ref14.colorGroups,
    plp = _ref14.plp;
  var items = [];

  // Metaobject order only; selection state does not reorder rows.
  // Always show all color_group rows — Algolia facet counts are conjunctive
  // (narrow when a colour is refined/preselected) and must not hide swatches.
  colorGroups.forEach(group => {
    var included = (group.included_colors || []).map(c => String(c).trim()).filter(Boolean);
    if (!included.length) return;
    var isSelected = included.some(c => selectedValues.includes(c));
    var safeFilter = escapeHtml(group.filter);
    if (isSelected) {
      items.push("\n                <li\n                    class=\"algolia-color-swatch__item algolia-color-swatch__item--selected algolia-color-swatch__item--toggle js--color-group-deselect-row\"\n                    data-color-group=\"".concat(safeFilter, "\"\n                    role=\"button\"\n                    tabindex=\"0\"\n                    aria-label=\"Remove ").concat(safeFilter, " colour filter\"\n                >\n                    ").concat(colorGroupSwatchHtml(group), "\n                    <span class=\"algolia-color-swatch__name\">").concat(safeFilter, "</span>\n                    <button\n                        type=\"button\"\n                        class=\"algolia-color-swatch__remove js--color-group-deselect\"\n                        data-color-group=\"").concat(safeFilter, "\"\n                        aria-label=\"Remove ").concat(safeFilter, " colour filter\"\n                    >").concat(CLOSE_SVG, "</button>\n                </li>"));
    } else {
      items.push("\n                <li\n                    class=\"algolia-color-swatch__item js--color-group-select\"\n                    data-color-group=\"".concat(safeFilter, "\"\n                    role=\"button\"\n                    tabindex=\"0\"\n                    aria-pressed=\"false\"\n                    aria-label=\"Filter by ").concat(safeFilter, "\"\n                >\n                    ").concat(colorGroupSwatchHtml(group), "\n                    <span class=\"algolia-color-swatch__name\">").concat(safeFilter, "</span>\n                </li>"));
    }
  });
  if (!items.length) {
    container.closest('.algolia-facet-group').hidden = true;
    return;
  }
  container.closest('.algolia-facet-group').hidden = false;
  container.innerHTML = "<ul class=\"algolia-color-swatch__list\">".concat(items.join(''), "</ul>");

  // Bind: select grouped colour
  container.querySelectorAll('.js--color-group-select').forEach(item => {
    var activate = () => {
      var group = colorGroups.find(g => g.filter === item.dataset.colorGroup);
      if (!group) return;
      var current = plp.state.refinements[attribute] || [];
      var toAdd = (group.included_colors || []).map(c => String(c).trim()).filter(c => c && !current.includes(c));
      plp.setRefinementValues(attribute, [...current, ...toAdd]);
    };
    item.addEventListener('click', activate);
    item.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activate();
      }
    });
  });
  var deselectColorGroup = filterName => {
    var group = colorGroups.find(g => g.filter === filterName);
    if (!group) return;
    var current = plp.state.refinements[attribute] || [];
    var remaining = current.filter(c => !(group.included_colors || []).includes(c));
    plp.setRefinementValues(attribute, remaining);
  };

  // Bind: deselect grouped colour (X button)
  container.querySelectorAll('.js--color-group-deselect').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      deselectColorGroup(btn.dataset.colorGroup);
    });
  });

  // Bind: deselect grouped colour (click row / keyboard)
  container.querySelectorAll('.js--color-group-deselect-row').forEach(row => {
    var act = e => {
      if (e.target.closest('.algolia-color-swatch__remove')) return;
      deselectColorGroup(row.dataset.colorGroup);
    };
    row.addEventListener('click', act);
    row.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        act(e);
      }
    });
  });
}

// ---------------------------------------------------------------------------
// Render: price range
// ---------------------------------------------------------------------------

function renderPriceRange(container, plp, priceAttribute, config) {
  var _window$theme2;
  container.closest('.algolia-facet-group').hidden = false;
  if (container.dataset.priceBound === '1') return;
  container.dataset.priceBound = '1';
  var minLabel = config.priceRangeMinLabel || 'Min';
  var maxLabel = config.priceRangeMaxLabel || 'Max';
  var currencySymbol = String(((_window$theme2 = window.theme) === null || _window$theme2 === void 0 || (_window$theme2 = _window$theme2.strings) === null || _window$theme2 === void 0 ? void 0 : _window$theme2.currencySymbol) || '').trim();
  container.innerHTML = "\n        <div class=\"algolia-price-range\">\n            <div class=\"algolia-price-range__inputs\">\n                <div class=\"algolia-price-range__col\">\n                    <label class=\"algolia-price-range__label\" for=\"algolia-price-range-min\">".concat(escapeHtml(minLabel), "</label>\n                    <div class=\"algolia-price-range__field\" data-currency-symbol=\"").concat(escapeHtml(currencySymbol), "\">\n                        <input\n                            type=\"number\"\n                            id=\"algolia-price-range-min\"\n                            class=\"algolia-price-range__input js--price-min\"\n                            min=\"0\"\n                            step=\"1\"\n                            inputmode=\"decimal\"\n                            autocomplete=\"off\"\n                        />\n                    </div>\n                </div>\n                <div class=\"algolia-price-range__col\">\n                    <label class=\"algolia-price-range__label\" for=\"algolia-price-range-max\">").concat(escapeHtml(maxLabel), "</label>\n                    <div class=\"algolia-price-range__field\" data-currency-symbol=\"").concat(escapeHtml(currencySymbol), "\">\n                        <input\n                            type=\"number\"\n                            id=\"algolia-price-range-max\"\n                            class=\"algolia-price-range__input js--price-max\"\n                            min=\"0\"\n                            step=\"1\"\n                            inputmode=\"decimal\"\n                            autocomplete=\"off\"\n                        />\n                    </div>\n                </div>\n            </div>\n            <div class=\"algolia-facet-checkbox\">\n                <label class=\"algolia-facet-checkbox__label\" for=\"algolia-sale-only\">\n                    <input\n                        type=\"checkbox\"\n                        id=\"algolia-sale-only\"\n                        class=\"algolia-facet-checkbox__input js--sale-only\"\n                    />\n                    <span class=\"algolia-facet-checkbox__text\">Sale</span>\n                </label>\n            </div>\n        </div>");
  var saleCheckbox = container.querySelector('.js--sale-only');
  saleCheckbox.checked = (plp.state.refinements[ALGOLIA_SALE_ATTRIBUTE] || []).includes(ALGOLIA_SALE_TOGGLE_VALUE);
  saleCheckbox.addEventListener('change', () => {
    plp.toggleRefinement(ALGOLIA_SALE_ATTRIBUTE, ALGOLIA_SALE_TOGGLE_VALUE);
  });
  var minInput = container.querySelector('.js--price-min');
  var maxInput = container.querySelector('.js--price-max');
  var timer;
  var currentRange = plp.state.numericRange[priceAttribute];
  if (currentRange) {
    if (currentRange.min != null) minInput.value = currentRange.min;
    if (currentRange.max != null) maxInput.value = currentRange.max;
  }
  var commit = () => {
    clearTimeout(timer);
    var min = minInput.value !== '' ? Number(minInput.value) : null;
    var max = maxInput.value !== '' ? Number(maxInput.value) : null;
    if (min == null && max == null) {
      plp.clearNumericRange(priceAttribute);
    } else {
      plp.setNumericRange(priceAttribute, {
        min,
        max
      });
    }
  };
  var schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(commit, PRICE_RANGE_DEBOUNCE_MS);
  };
  minInput.addEventListener('input', schedule);
  maxInput.addEventListener('input', schedule);
  minInput.addEventListener('change', commit);
  maxInput.addEventListener('change', commit);
}

// ---------------------------------------------------------------------------
// Render: sort select
// ---------------------------------------------------------------------------

function renderSort(container, sortReplicas, currentIndex, plp, _ref15) {
  var prefix = _ref15.prefix;
  if (!sortReplicas.length) {
    var _sortSection = container.closest('.algolia-filter-bar__sort');
    if (_sortSection) _sortSection.classList.add('algolia-filter-bar__sort--hidden');
    return;
  }
  var sortSection = container.closest('.algolia-filter-bar__sort');
  if (sortSection) sortSection.classList.remove('algolia-filter-bar__sort--hidden');
  var options = sortReplicas.map(r => "<option value=\"".concat(escapeHtml(r.value), "\" ").concat(r.value === currentIndex ? 'selected' : '', ">").concat(escapeHtml(prefix ? "Sort by: ".concat(r.label) : r.label), "</option>")).join('');
  container.innerHTML = "<select class=\"algolia-sort__select\" aria-label=\"Sort products\">".concat(options, "</select>");
  container.querySelector('.algolia-sort__select').addEventListener('change', e => {
    plp.setSort(e.target.value);
  });
}
function updateSortSelects(containers, currentIndex) {
  containers.forEach(c => {
    var select = c && c.querySelector('.algolia-sort__select');
    if (select && select.value !== currentIndex) select.value = currentIndex;
  });
}

// ---------------------------------------------------------------------------
// Render: current refinements tags
// ---------------------------------------------------------------------------

function renderCurrentRefinements(container, state, plp, priceAttribute, colorGroups) {
  var tags = [];
  var _loop = function _loop() {
      _ref17 = _slicedToArray(_ref18, 2);
      var attr = _ref17[0];
      var values = _ref17[1];
      if (attr === ALGOLIA_COLOR_ATTRIBUTE && colorGroups.length > 0) {
        // One tag per active colour group, same order as metaobjects / sidebar
        colorGroups.forEach(group => {
          var groupSelected = (group.included_colors || []).filter(c => values.includes(c));
          if (!groupSelected.length) return;
          tags.push({
            attr,
            label: group.filter,
            type: 'colorGroup',
            groupColors: groupSelected
          });
        });
      } else {
        for (var val of values) {
          var label = attr === ALGOLIA_SALE_ATTRIBUTE ? 'Sale' : val;
          tags.push({
            attr,
            value: val,
            label,
            type: 'refinement'
          });
        }
      }
    },
    _ref17;
  for (var _ref18 of Object.entries(state.refinements)) {
    _loop();
  }
  for (var _ref21 of Object.entries(state.numericRange)) {
    var _ref20 = _slicedToArray(_ref21, 2);
    var attr = _ref20[0];
    var range = _ref20[1];
    var parts = [];
    if (range.min != null) parts.push("$".concat(range.min));
    if (range.max != null) parts.push("$".concat(range.max));
    if (parts.length) {
      tags.push({
        attr,
        value: null,
        label: parts.join(' – '),
        type: 'numeric'
      });
    }
  }
  if (!tags.length) {
    container.innerHTML = '';
    return;
  }
  container.innerHTML = tags.map(t => "\n        <span class=\"algolia-tag\">\n            <span class=\"algolia-tag__label\">".concat(escapeHtml(t.label), "</span>\n            <button\n                type=\"button\"\n                class=\"algolia-tag__remove\"\n                data-tag-attr=\"").concat(escapeHtml(t.attr), "\"\n                data-tag-value=\"").concat(t.value != null ? escapeHtml(t.value) : '', "\"\n                data-tag-type=\"").concat(t.type, "\"\n                data-tag-group-colors=\"").concat(t.groupColors ? encodeURIComponent(JSON.stringify(t.groupColors)) : '', "\"\n                aria-label=\"Remove ").concat(escapeHtml(t.label), "\"\n            >&times;</button>\n        </span>")).join('');
  container.querySelectorAll('.algolia-tag').forEach(tag => {
    tag.addEventListener('click', e => {
      if (e.target.closest('.algolia-tag__remove')) return;
      var rm = tag.querySelector('.algolia-tag__remove');
      if (rm) rm.click();
    });
  });
  container.querySelectorAll('.algolia-tag__remove').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.tagType === 'numeric') {
        plp.clearNumericRange(btn.dataset.tagAttr);
        var priceContainer = document.querySelector("[data-facet-attr=\"".concat(priceAttribute, "\"]"));
        if (priceContainer) {
          var minInput = priceContainer.querySelector('.js--price-min');
          var maxInput = priceContainer.querySelector('.js--price-max');
          if (minInput) minInput.value = '';
          if (maxInput) maxInput.value = '';
        }
      } else if (btn.dataset.tagType === 'colorGroup') {
        var groupColors = [];
        try {
          var enc = btn.dataset.tagGroupColors;
          groupColors = enc ? JSON.parse(decodeURIComponent(enc)) : [];
        } catch (_unused6) {
          groupColors = [];
        }
        var current = plp.state.refinements[btn.dataset.tagAttr] || [];
        var remaining = current.filter(c => !groupColors.includes(c));
        plp.setRefinementValues(btn.dataset.tagAttr, remaining);
      } else {
        plp.clearRefinement(btn.dataset.tagAttr, btn.dataset.tagValue);
      }
    });
  });
}

// ---------------------------------------------------------------------------
// Render: clear all
// ---------------------------------------------------------------------------

function renderClearAll(container, hasRefinements, plp, priceAttribute) {
  if (!hasRefinements) {
    container.innerHTML = '';
    return;
  }
  container.innerHTML = '<button type="button" class="algolia-clear-all">Clear All</button>';
  container.querySelector('.algolia-clear-all').addEventListener('click', () => {
    plp.clearAll();
    var priceContainer = document.querySelector("[data-facet-attr=\"".concat(priceAttribute, "\"]"));
    if (priceContainer) {
      var minInput = priceContainer.querySelector('.js--price-min');
      var maxInput = priceContainer.querySelector('.js--price-max');
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';
    }
  });
}

// ---------------------------------------------------------------------------
// Render: page delta button
// ---------------------------------------------------------------------------

function renderPageDeltaButton(container, page, nbPages, plp, delta, label) {
  var targetPage = page + delta;
  if (targetPage < 1 || targetPage > nbPages) {
    container.innerHTML = '';
    container.hidden = true;
    return;
  }
  container.hidden = false;
  container.innerHTML = "\n        <div class=\"algolia-pagination__nav\">\n            <button type=\"button\" class=\"button button--primary algolia-pagination__button\" data-page=\"".concat(targetPage, "\">\n                ").concat(escapeHtml(label), "\n            </button>\n        </div>");
  var button = container.querySelector('.algolia-pagination__button');
  button.addEventListener('click', () => {
    button.disabled = true;
    plp.setPage(targetPage);
  });
}

// ---------------------------------------------------------------------------
// Facet group headings: selected refinement count (list / swatches only)
// ---------------------------------------------------------------------------

function updateFacetGroupCounts(facetsMount, state, priceAttribute, colorGroups) {
  facetsMount.querySelectorAll('.algolia-facet-group').forEach(group => {
    var countEl = group.querySelector('.algolia-facet-group__selected-count');
    if (!countEl) return;
    var attr = group.dataset.facetAttr;
    var type = group.dataset.facetType;

    // Only refinement lists and colour swatches; never price / range.
    if (type === 'rangeInput' || attr === priceAttribute) {
      countEl.textContent = '';
      countEl.hidden = true;
      return;
    }
    var vals = state.refinements[attr] || [];
    var n = 0;
    if (type === 'colorSwatches') {
      n = colorGroups.length > 0 ? countSelectedColorGroups(vals, colorGroups) : vals.length;
    } else if (type === 'refinementList') {
      n = vals.length;
    }
    var show = n > 0;
    countEl.textContent = show ? " (".concat(n, ")") : '';
    countEl.hidden = !show;
  });
}

// ---------------------------------------------------------------------------
// Filter bar — dock full bar to bottom when scroll sentinel passes viewport
// ---------------------------------------------------------------------------

var ALGOLIA_FILTER_BAR_DOCK_CLASS = 'algolia-filter-bar--docked-bottom';
var ALGOLIA_FILTER_BAR_OUT_OF_BOUNDS_CLASS = 'algolia-filter-bar--out-of-bounds';

/**
 * @param {HTMLElement} filterBar
 * @param {HTMLElement | null} scrollSentinel
 * @param {HTMLElement | null} placeholder
 * @param {HTMLElement | null} sectionBoundsElement
 */
function initAlgoliaFilterBarBottomDock(filterBar, scrollSentinel, placeholder, sectionBoundsElement) {
  if (!placeholder) {
    return;
  }
  var target = scrollSentinel || filterBar;
  var resizeObserver = null;
  var dockBarSlotBaselinePx = null;

  // Hysteresis: dock the moment the sentinel leaves the top of the viewport,
  // but don't undock until it is clearly back in view. Because the placeholder
  // compensates exactly for the bar leaving the flow, the sentinel would
  // otherwise dwell right at bottom === 0, so sub-pixel scroll jitter flaps the
  // dock class and replays the entrance animation — the source of the flicker.
  var DOCK_UNDOCK_BUFFER_PX = 40;
  var shouldBeDocked = sentinelBottom => {
    if (filterBar.classList.contains(ALGOLIA_FILTER_BAR_DOCK_CLASS)) {
      return sentinelBottom < DOCK_UNDOCK_BUFFER_PX;
    }
    return sentinelBottom <= 0;
  };
  var syncDockedLayout = () => {
    if (!filterBar.classList.contains(ALGOLIA_FILTER_BAR_DOCK_CLASS)) {
      return;
    }
    var pr = placeholder.getBoundingClientRect();
    if (pr.width > 0) {
      filterBar.style.setProperty('--algolia-filter-bar-dock-left', "".concat(pr.left, "px"));
      filterBar.style.setProperty('--algolia-filter-bar-dock-width', "".concat(pr.width, "px"));
    }
    var barH = filterBar.offsetHeight;
    var h = dockBarSlotBaselinePx != null ? Math.max(dockBarSlotBaselinePx, barH) : barH;
    placeholder.style.height = h > 0 ? "".concat(h, "px") : '';
  };
  var stopResizeObserver = () => {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  };
  var onWinResize = () => {
    if (filterBar.classList.contains(ALGOLIA_FILTER_BAR_DOCK_CLASS) || filterBar.classList.contains(ALGOLIA_FILTER_BAR_OUT_OF_BOUNDS_CLASS)) {
      requestAnimationFrame(syncDockedLayout);
    }
    requestAnimationFrame(syncDockFromRect);
  };
  window.addEventListener('resize', onWinResize);
  var applyDocked = docked => {
    if (docked) {
      if (!filterBar.classList.contains(ALGOLIA_FILTER_BAR_DOCK_CLASS)) {
        var _scrollSentinel$getBo;
        var shell = filterBar.closest('.algolia-filter-bar-shell');
        var shellBox = shell === null || shell === void 0 ? void 0 : shell.getBoundingClientRect();
        var sentinelH = (_scrollSentinel$getBo = scrollSentinel === null || scrollSentinel === void 0 ? void 0 : scrollSentinel.getBoundingClientRect().height) !== null && _scrollSentinel$getBo !== void 0 ? _scrollSentinel$getBo : 0;
        var barRect = filterBar.getBoundingClientRect();
        dockBarSlotBaselinePx = Math.max(0, shellBox.height - sentinelH);
        var geo = shellBox !== null && shellBox !== void 0 ? shellBox : barRect;
        filterBar.classList.add(ALGOLIA_FILTER_BAR_DOCK_CLASS);
        filterBar.style.setProperty('--algolia-filter-bar-dock-left', "".concat(geo.left, "px"));
        filterBar.style.setProperty('--algolia-filter-bar-dock-width', "".concat(geo.width, "px"));
        placeholder.style.height = "".concat(Math.max(dockBarSlotBaselinePx, barRect.height), "px");
        requestAnimationFrame(syncDockedLayout);
        stopResizeObserver();
        if (typeof ResizeObserver !== 'undefined') {
          resizeObserver = new ResizeObserver(syncDockedLayout);
          resizeObserver.observe(filterBar);
        }
      } else {
        syncDockedLayout();
      }
    } else if (filterBar.classList.contains(ALGOLIA_FILTER_BAR_DOCK_CLASS)) {
      filterBar.classList.remove(ALGOLIA_FILTER_BAR_DOCK_CLASS);
      filterBar.style.removeProperty('--algolia-filter-bar-dock-left');
      filterBar.style.removeProperty('--algolia-filter-bar-dock-width');
      placeholder.style.height = '';
      dockBarSlotBaselinePx = null;
      stopResizeObserver();
    }
  };
  var applyOutOfBounds = outOfBounds => {
    filterBar.classList.toggle(ALGOLIA_FILTER_BAR_OUT_OF_BOUNDS_CLASS, outOfBounds);
  };
  var isPastSectionBottom = () => {
    if (!sectionBoundsElement) {
      return false;
    }
    var sectionRect = sectionBoundsElement.getBoundingClientRect();
    return sectionRect.bottom <= 0;
  };
  var syncDockFromRect = () => {
    if (target.offsetWidth === 0 && target.offsetHeight === 0) {
      applyDocked(false);
      return;
    }
    var outOfBounds = isPastSectionBottom();
    applyOutOfBounds(outOfBounds);
    if (outOfBounds) {
      return;
    }
    var r = target.getBoundingClientRect();
    applyDocked(shouldBeDocked(r.bottom));
  };
  var observer = new IntersectionObserver(_ref22 => {
    var _ref23 = _slicedToArray(_ref22, 1),
      entry = _ref23[0];
    if (!entry) {
      return;
    }
    var r = entry.boundingClientRect;
    if (r.width === 0 && r.height === 0) {
      applyDocked(false);
      return;
    }
    applyDocked(shouldBeDocked(r.bottom));
  }, {
    threshold: 0
  });
  observer.observe(target);

  // The IntersectionObserver only fires on 0-crossings, so it can't detect the
  // sentinel returning past the undock buffer. Re-evaluate on scroll (rAF
  // throttled) so the docked state settles with hysteresis instead of flapping.
  var scrollFrame = 0;
  var onScroll = () => {
    if (scrollFrame) {
      return;
    }
    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = 0;
      syncDockFromRect();
    });
  };
  window.addEventListener('scroll', onScroll, {
    passive: true
  });
  if (sectionBoundsElement) {
    var sectionBoundsObserver = new IntersectionObserver(() => {
      syncDockFromRect();
    }, {
      threshold: 0
    });
    sectionBoundsObserver.observe(sectionBoundsElement);
  }
  requestAnimationFrame(syncDockFromRect);
}

/**
 * Formats hit count (and search query when using search copy) for the search
 * hero subtitle and the filter drawer hits line.
 *
 * @param {number} nbHits
 * @param {string} query
 * @param {'search' | 'collection'} mode
 */
function formatAlgoliaHitSubtitle(nbHits, query, mode) {
  var _window$theme3;
  var t = ((_window$theme3 = window.theme) === null || _window$theme3 === void 0 ? void 0 : _window$theme3.strings) || {};
  var count = Number(nbHits) || 0;
  var q = decodeHtmlEntities(query).trim();
  var tier = count === 0 ? 'zero' : count === 1 ? 'one' : 'other';
  var strings = mode === 'search' ? {
    'empty:zero': t.searchAlgoliaSubtitleEmptyZero,
    'empty:one': t.searchAlgoliaSubtitleEmptyOne,
    'empty:other': t.searchAlgoliaSubtitleEmptyOther,
    'query:zero': t.searchAlgoliaSubtitleZero,
    'query:one': t.searchAlgoliaSubtitleOne,
    'query:other': t.searchAlgoliaSubtitleOther
  } : {
    zero: t.algoliaDrawerHitsZero,
    one: t.algoliaDrawerHitsOne,
    other: t.algoliaDrawerHitsOther
  };
  var key = mode === 'search' ? "".concat(q ? 'query' : 'empty', ":").concat(tier) : tier;
  var tpl = strings[key];
  return decodeHtmlEntities(String(tpl || '').replace(/__COUNT__/g, String(count)).replace(/__TERMS__/g, q));
}

/**
 * Debounced search input + Algolia subtitle sync (search template only).
 * @returns {{ updateSubtitle: Function, syncInput: Function } | null}
 */
function mountAlgoliaSearchHeader(plp, _ref24) {
  var subtitleEl = _ref24.subtitleEl,
    searchInput = _ref24.searchInput,
    searchForm = _ref24.searchForm;
  if (!searchInput && !subtitleEl) return null;
  var debounceTimer = null;
  function flushQueryFromInput() {
    if (!searchInput) return;
    plp.setQuery(searchInput.value.trim());
  }
  function scheduleDebouncedQuery() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      flushQueryFromInput();
    }, SEARCH_HEADER_DEBOUNCE_MS);
  }
  if (searchForm) {
    searchForm.addEventListener('submit', e => {
      e.preventDefault();
      clearTimeout(debounceTimer);
      debounceTimer = null;
      flushQueryFromInput();
    });
  }
  if (searchInput) {
    searchInput.addEventListener('input', scheduleDebouncedQuery);
    searchInput.addEventListener('keydown', e => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      clearTimeout(debounceTimer);
      debounceTimer = null;
      flushQueryFromInput();
    });
  }
  return {
    updateSubtitle(hitCount, q) {
      if (!subtitleEl) return;
      subtitleEl.textContent = formatAlgoliaHitSubtitle(hitCount, q, 'search');
    },
    syncInput(q) {
      if (!searchInput) return;
      if (document.activeElement === searchInput) return;
      var next = String(q !== null && q !== void 0 ? q : '');
      if (searchInput.value !== next) {
        searchInput.value = next;
      }
    }
  };
}

/**
 * Empty state shown on the search results page when a query returns zero
 * hits. Renders a static intro message plus a wrap of popular search-term
 * chips fetched from the Query Suggestions index.
 *
 * Returns null when the markup isn't present (collection PLP, etc.) or
 * when the search header isn't available to receive new queries.
 *
 * @param {{ searchInput: HTMLInputElement | null, searchForm: HTMLFormElement | null }} headerRefs
 * @returns {{ toggle: (visible: boolean) => void } | null}
 */
function mountAlgoliaSearchEmptyState(_ref25) {
  var searchInput = _ref25.searchInput,
    searchForm = _ref25.searchForm;
  var root = document.querySelector('[data-search-empty-state]');
  if (!root) return null;
  var chipsWrap = root.querySelector('[data-search-empty-state-chips]');
  var chipsRequested = false;
  function applyTerm(term) {
    if (!searchInput) return;
    searchInput.value = term;
    if (searchForm) {
      // Form submit path immediately flushes the new query (skips debounce).
      searchForm.dispatchEvent(new Event('submit', {
        cancelable: true,
        bubbles: true
      }));
    } else {
      searchInput.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
    searchInput.focus({
      preventScroll: true
    });
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  function renderChips(terms) {
    if (!chipsWrap) return;
    chipsWrap.innerHTML = '';
    if (!terms.length) {
      chipsWrap.hidden = true;
      return;
    }
    var _loop2 = function _loop2(term) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button button--ghost-reversed search-empty-state__chip';
      btn.textContent = term;
      btn.addEventListener('click', () => applyTerm(term));
      chipsWrap.appendChild(btn);
    };
    for (var term of terms) {
      _loop2(term);
    }
    chipsWrap.hidden = false;
  }
  function loadChipsOnce() {
    if (chipsRequested || !chipsWrap) return;
    chipsRequested = true;
    var cfg = window.algoliaPlp || {};
    var client;
    try {
      client = getAlgoliaClient();
    } catch (e) {
      console.warn('[Algolia] Empty-state client unavailable', e);
      return;
    }
    fetchPopularTerms(client, cfg, SEARCH_EMPTY_STATE_CHIPS_LIMIT).then(terms => renderChips(terms)).catch(e => {
      chipsRequested = false;
      console.warn('[Algolia] Empty-state chips fetch failed', e);
    });
  }
  return {
    toggle(visible) {
      root.hidden = !visible;
      if (visible) loadChipsOnce();
    }
  };
}

// ---------------------------------------------------------------------------
// Init
// ---------------------------------------------------------------------------

function initAlgoliaListing() {
  var root = document.querySelector('[data-algolia-listing-root]');
  if (!root) return;
  var config = window.algoliaPlp;
  if (!config) return;
  var appId = config.appId;
  var searchApiKey = config.searchApiKey;
  var indexName = getAlgoliaProductIndexName();
  var hitsPerPage = Number(config.hitsPerPage) || 12;
  if (!appId || !searchApiKey) {
    console.warn('[Algolia Listing] Missing appId or searchApiKey.');
    return;
  }
  var mode = root.dataset.algoliaMode;
  var collectionId = root.dataset.algoliaCollectionId;
  var collectionHandle = root.dataset.algoliaCollectionHandle;
  var enableSorting = root.dataset.algoliaEnableSorting !== 'false';
  var enableFiltering = root.dataset.algoliaEnableFiltering !== 'false';
  var priceAttribute = ALGOLIA_PRICE_ATTRIBUTE;
  var priceScale = ALGOLIA_PRICE_FILTER_SCALE;
  var colorGroups = parseColorGroups(root);
  var inlineContentRows = parseInlineContentRows(root);
  var inlineFeaturedRows = parseInlineFeaturedProductRows(root);
  setAlgoliaSwatchColorLookup(readAlgoliaSwatchColorLookup(root));
  var insertedInlineIds = new Set();
  var insertedFeaturedIds = new Set();
  var previousStateKey = '';
  var loadedPageMin = null;
  var loadedPageMax = null;

  // DOM references
  var filterBar = document.querySelector('[data-algolia-filter-bar]');
  if (!filterBar && (enableSorting || enableFiltering)) {
    console.warn('[Algolia Listing] Missing filter bar.');
    return;
  }
  var scrollSentinel = document.querySelector('[data-algolia-filter-bar-scroll-sentinel]');
  var filterBarPlaceholder = document.querySelector('[data-algolia-filter-bar-placeholder]');
  if (filterBar) {
    initAlgoliaFilterBarBottomDock(filterBar, scrollSentinel, filterBarPlaceholder, root);
  }
  var countEls = document.querySelectorAll('.js--algolia-filter-count');
  var drawerFilterCountEl = document.querySelector('.js--algolia-drawer-filter-count');
  var drawerHitsCountEl = document.querySelector('.js--algolia-drawer-hits-count');
  var drawerAppliedFiltersEl = document.querySelector('.js--algolia-drawer-applied-filters');
  var productGrid = document.getElementById('ProductGrid');
  var paginationPreviousMount = document.getElementById('AlgoliaPaginationPrevious');
  var paginationMount = document.getElementById('AlgoliaPagination');
  var sortMount = document.getElementById('AlgoliaSortBy');
  var sortMountMobile = document.getElementById('AlgoliaSortByMobile');
  var barTagsMount = document.getElementById('AlgoliaCurrentRefinements');
  var barClearMount = document.getElementById('AlgoliaClearAll');
  var drawerTagsMount = document.getElementById('AlgoliaCurrentRefinementsDrawer');
  var drawerClearMount = document.getElementById('AlgoliaClearAllDrawer');
  var facetsMount = document.getElementById('AlgoliaFacetsMount');
  if (enableFiltering && !facetsMount) {
    console.warn('[Algolia Listing] Missing #AlgoliaFacetsMount');
    return;
  }
  var collectionFacetValue = String(collectionHandle !== null && collectionHandle !== void 0 ? collectionHandle : '').trim().toLowerCase();
  var applyCollectionFacet = shouldApplyCollectionFacetFilter({
    mode,
    collectionHandle,
    config
  });
  if (applyCollectionFacet && !collectionFacetValue) {
    console.error('[Algolia Listing] Collection page needs data-algolia-collection-handle.');
    return;
  }
  var scopeFilters = collectionFacetFilters(collectionFacetValue, applyCollectionFacet);

  // Build facet group DOM
  if (facetsMount) facetsMount.innerHTML = '';
  var facetContainers = {};
  if (enableFiltering) {
    ALGOLIA_PLP_FACETS.forEach(facet => {
      var group = document.createElement('div');
      var attr = facet.type === 'rangeInput' ? priceAttribute : facet.attribute;
      group.className = facet.type === 'rangeInput' ? 'algolia-facet-group algolia-facet-group--price-range' : 'algolia-facet-group';
      group.dataset.facetAttr = attr;
      group.dataset.facetType = facet.type;
      group.innerHTML = "\n            <div class=\"algolia-facet-group__title\" role=\"button\" tabindex=\"0\" aria-expanded=\"true\">\n                <span class=\"algolia-facet-group__label\">\n                    <span class=\"algolia-facet-group__label-text\">".concat(escapeHtml(facet.label), "</span>\n                    <span class=\"algolia-facet-group__selected-count\" hidden></span>\n                </span>\n                <svg class=\"icon icon__arrow--down algolia-facet-group__arrow\" aria-hidden=\"true\" focusable=\"false\">\n                    <use xlink:href=\"#icon-arrow--down\"></use>\n                </svg>\n            </div>\n            <div class=\"algolia-facet-group__control\" data-facet-attr=\"").concat(escapeHtml(attr), "\"></div>");
      facetsMount.appendChild(group);
      facetContainers[attr] = {
        control: group.querySelector('.algolia-facet-group__control'),
        facet
      };
    });
  }

  // Accordion
  if (enableFiltering) {
    facetsMount.addEventListener('click', e => {
      var title = e.target.closest('.algolia-facet-group__title');
      if (!title) return;
      var group = title.closest('.algolia-facet-group');
      if (!group) return;
      group.classList.toggle('algolia-facet-group--collapsed');
      title.setAttribute('aria-expanded', String(!group.classList.contains('algolia-facet-group--collapsed')));
    });
  }
  if (enableFiltering) {
    facetsMount.addEventListener('keydown', e => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('algolia-facet-group__title')) {
        e.preventDefault();
        e.target.click();
      }
    });
  }

  // Read initial query for search mode
  var initialQuery = mode === 'search' ? new URLSearchParams(window.location.search).get('q') || '' : '';
  var sortReplicas = enableSorting ? getAlgoliaSortReplicas() : [];
  var defaultFilters = mode === 'collection' ? parsePreselectedFiltersFromRoot(root, {
    facets: enableFiltering ? ALGOLIA_PLP_FACETS : [],
    sortReplicas
  }) : null;

  // Create PLP instance
  var plp = createAlgoliaPlp({
    appId,
    searchApiKey,
    indexName,
    facets: enableFiltering ? ALGOLIA_PLP_FACETS : [],
    sortReplicas,
    priceScale,
    hitsPerPage,
    collectionFacetFilters: scopeFilters,
    separateCardAttr: mode === 'collection' ? SEPARATE_CARD_FILTER_ATTR : null,
    urlSync: true,
    defaultFilters
  });
  if (initialQuery && !plp.state.query) {
    plp.state.query = initialQuery;
  }
  var headerRoot = document.querySelector('[data-search-results-header]');
  var searchInputEl = (headerRoot === null || headerRoot === void 0 ? void 0 : headerRoot.querySelector('[data-search-results-input]')) || null;
  var searchFormEl = (headerRoot === null || headerRoot === void 0 ? void 0 : headerRoot.querySelector('[data-search-results-form]')) || null;
  var searchHeaderCtl = mode === 'search' ? mountAlgoliaSearchHeader(plp, {
    subtitleEl: document.querySelector('[data-search-results-subtitle]'),
    searchInput: searchInputEl,
    searchForm: searchFormEl
  }) : null;
  var searchEmptyStateCtl = mode === 'search' ? mountAlgoliaSearchEmptyState({
    searchInput: searchInputEl,
    searchForm: searchFormEl
  }) : null;

  // Render sort selects once (values updated on results)
  if (enableSorting && sortMount) {
    renderSort(sortMount, sortReplicas, plp.state.sortIndex, plp, {
      prefix: true
    });
  }
  if (enableSorting && sortMountMobile) {
    renderSort(sortMountMobile, sortReplicas, plp.state.sortIndex, plp, {
      prefix: false
    });
  }

  // Render price range once (it's a persistent input, not re-rendered per search)
  var priceEntry = facetContainers[priceAttribute];
  if (enableFiltering && priceEntry && priceEntry.facet.type === 'rangeInput') {
    renderPriceRange(priceEntry.control, plp, priceAttribute, config);
  }

  // Results handler
  plp.on('results', _ref26 => {
    var state = _ref26.state,
      hits = _ref26.hits,
      separateCardHits = _ref26.separateCardHits,
      facets = _ref26.facets,
      nbHits = _ref26.nbHits,
      nbPages = _ref26.nbPages,
      page = _ref26.page;
    var currentStateKey = JSON.stringify({
      mode,
      collectionId,
      sortIndex: state.sortIndex,
      query: state.query,
      refinements: state.refinements,
      numericRange: state.numericRange
    });
    var sameState = currentStateKey === previousStateKey;
    var shouldPrepend = sameState && loadedPageMin != null && page === loadedPageMin - 1;
    var shouldAppend = sameState && loadedPageMax != null && page === loadedPageMax + 1;
    var shouldReplace = !shouldPrepend && !shouldAppend;
    if (shouldReplace) {
      insertedInlineIds = new Set();
      insertedFeaturedIds = new Set();
      loadedPageMin = page;
      loadedPageMax = page;
    }
    var streamIndexStart = (Math.max(1, page) - 1) * hitsPerPage + 1;

    // Product grid
    if (productGrid) {
      var displayHits = mode === 'collection' && separateCardHits !== null && separateCardHits !== void 0 && separateCardHits.length ? mergeSeparateCardHits(hits, separateCardHits, collectionFacetValue) : hits;
      var renderInfo = renderHits(productGrid, displayHits, inlineContentRows, inlineFeaturedRows, {
        append: shouldAppend,
        prepend: shouldPrepend,
        streamIndexStart,
        alreadyInsertedInlineIds: insertedInlineIds,
        alreadyInsertedFeaturedIds: insertedFeaturedIds
      });
      insertedInlineIds = renderInfo.insertedInlineIds;
      insertedFeaturedIds = renderInfo.insertedFeaturedIds;
    }
    if (shouldPrepend) {
      loadedPageMin = page;
    } else if (shouldAppend) {
      loadedPageMax = page;
    }
    previousStateKey = currentStateKey;
    var noResults = !nbHits;
    root.classList.toggle('filters-sort-grid-container--no-results', noResults);
    searchEmptyStateCtl === null || searchEmptyStateCtl === void 0 || searchEmptyStateCtl.toggle(noResults);

    // Facets
    if (enableFiltering) {
      for (var _ref29 of Object.entries(facetContainers)) {
        var _ref28 = _slicedToArray(_ref29, 2);
        var attr = _ref28[0];
        var entry = _ref28[1];
        if (entry.facet.type === 'rangeInput') continue;
        var facetValues = facets[attr] || {};
        var selected = state.refinements[attr] || [];
        if (entry.facet.type === 'colorSwatches') {
          renderColorSwatches(entry.control, facetValues, selected, {
            attribute: attr,
            colorGroups,
            plp
          });
        } else {
          renderRefinementList(entry.control, facetValues, selected, {
            limit: entry.facet.limit || DEFAULT_FACET_LIMIT,
            attribute: attr,
            plp
          });
        }
      }
    }

    // Sync Sale Only checkbox state
    if (enableFiltering && priceEntry) {
      var saleCheckbox = priceEntry.control.querySelector('.js--sale-only');
      if (saleCheckbox) {
        saleCheckbox.checked = (state.refinements[ALGOLIA_SALE_ATTRIBUTE] || []).includes(ALGOLIA_SALE_TOGGLE_VALUE);
      }
    }

    // Facet group badges
    if (enableFiltering) {
      updateFacetGroupCounts(facetsMount, state, priceAttribute, colorGroups);
    }

    // Filter count on button (groups count as 1 even if multiple colors selected)
    var filterCount = enableFiltering ? computeActiveFilterCount(state, colorGroups) : 0;
    countEls.forEach(el => {
      if (filterCount > 0) {
        el.textContent = "(".concat(filterCount, ")");
        el.removeAttribute('hidden');
      } else {
        el.textContent = '';
        el.setAttribute('hidden', '');
      }
    });

    // Drawer header
    if (drawerFilterCountEl) {
      drawerFilterCountEl.textContent = filterCount > 0 ? "(".concat(filterCount, ")") : '';
    }
    if (drawerHitsCountEl) {
      drawerHitsCountEl.textContent = formatAlgoliaHitSubtitle(nbHits, state.query, mode);
    }
    if (drawerAppliedFiltersEl) {
      if (filterCount > 0) {
        drawerAppliedFiltersEl.removeAttribute('hidden');
      } else {
        drawerAppliedFiltersEl.setAttribute('hidden', '');
      }
    }

    // Current refinement tags (bar + drawer)
    var hasRefinements = filterCount > 0;
    if (filterBar) filterBar.toggleAttribute('data-has-refinements', hasRefinements);
    if (barTagsMount) {
      renderCurrentRefinements(barTagsMount, state, plp, priceAttribute, colorGroups);
    }
    if (barClearMount) {
      renderClearAll(barClearMount, hasRefinements, plp, priceAttribute);
    }
    if (drawerTagsMount) {
      renderCurrentRefinements(drawerTagsMount, state, plp, priceAttribute, colorGroups);
    }
    if (drawerClearMount) {
      renderClearAll(drawerClearMount, hasRefinements, plp, priceAttribute);
    }

    // Sort select sync
    if (enableSorting) {
      updateSortSelects([sortMount, sortMountMobile], state.sortIndex);
    }

    // Page range controls
    if (paginationPreviousMount) renderPageDeltaButton(paginationPreviousMount, loadedPageMin, nbPages, plp, -1, config.loadPreviousLabel || 'Load Previous');
    if (paginationMount) renderPageDeltaButton(paginationMount, loadedPageMax, nbPages, plp, 1, config.loadMoreLabel || 'Load More');
    if (mode === 'search' && searchHeaderCtl) {
      searchHeaderCtl.syncInput(state.query);
      searchHeaderCtl.updateSubtitle(nbHits, state.query);
    }
  });

  // Initial search
  plp.search();
}
document.addEventListener('DOMContentLoaded', initAlgoliaListing);